/* assets/mpb.js */
/* MPB: current page is the bundle parent + swatches render immediately (split too) */
(function () {
  // Remember each (bid, slot) selection for the life of the page so a section
  // repaint / re-init restores the shopper's picks instead of snapping back to
  // the default variant. Declared first: boot() runs synchronously below for a
  // deferred script, so this must be initialized before init()/renderAll() use it.
  const MPB_SEL = (window.__MPB_SEL = window.__MPB_SEL || new Map());

  // ---------- helpers ----------

  /* Shop-currency amounts formatted with the shopper's currency code read as the wrong
   * number, so convert with Shopify's published rate for the active market first. */
  function __presentmentRate() {
    try {
      const r = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || "1");
      return isFinite(r) && r > 0 ? r : 1;
    } catch (e) { return 1; }
  }
  function moneyFmt(cents) {
    const locale = document.documentElement.lang || "en-US";
    const currency = (window.Shopify?.currency?.active) || "USD";
    const amount = ((Number(cents) || 0) / 100) * __presentmentRate();
    // Whole-dollar amounts drop the trailing ".00"; cents are kept (e.g. $24, $24.99).
    const fractionDigits = Number.isInteger(amount) ? 0 : 2;
    try { return new Intl.NumberFormat(locale, { style:"currency", currency, minimumFractionDigits: fractionDigits, maximumFractionDigits: 2 }).format(amount); }
    catch { return `$${fractionDigits ? amount.toFixed(2) : amount.toFixed(0)}`; }
  }
  function parseJSONSafe(text, fallback=[]) { try { return JSON.parse(text); } catch { return fallback; } }
  function readPayload(root, bid){
    const node = root.querySelector(`#mpb-products-${bid}`);
    let data = [];
    if (node) data = parseJSONSafe(node.textContent || "[]", []);
    if (!Array.isArray(data) || data.length === 0) {
      const inline = root.getAttribute('data-products');
      if (inline) data = parseJSONSafe(inline, []);
    }
    return Array.isArray(data) ? data : [];
  }
  const uuid = () =>
    (window.crypto?.randomUUID?.() ||
      "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = Math.random()*16|0, v = c==="x"?r:(r&0x3|0x8); return v.toString(16);
      })
    );

  // ---------- color map ----------
  // Built-in fallbacks for when the theme swatch map isn't present. The theme map
  // (injected inline before this script as window.MPB_COLOR_HEX, with UPPERCASE keys
  // like "LILAC") must win over these — so we normalize EVERY key to lowercase into
  // MPB_HEX. Because the theme map is Object.assign'd second, its values overwrite the
  // fallbacks at the same lowercased key, regardless of the product option's casing.
  window.MPB_COLOR_HEX = Object.assign({
    "Lilac":"#C8B7FF","Poppy":"#FF6B6B","Sky Blue":"#89C2FF","Oat":"#E9E1D1","Green":"#47B276",
    "Blueberry":"#6C7BFF","Black":"#000000","White":"#FFFFFF","Gray":"#999999","Grey":"#999999",
    "Red":"#E11900","Orange":"#FA6400","Yellow":"#FFC400","Pink":"#FF9AC2","Purple":"#7A5AF8",
    "Navy":"#1F2D5A","Beige":"#E7DCC8","Brown":"#8E6E53"
  }, window.MPB_COLOR_HEX || {});

  const MPB_HEX = {};
  Object.keys(window.MPB_COLOR_HEX).forEach(k => {
    MPB_HEX[String(k).trim().toLowerCase()] = window.MPB_COLOR_HEX[k];
  });

  function hexFor(name) {
    if (!name) return "#EEE";
    const key = String(name).trim().toLowerCase();
    if (MPB_HEX[key]) return MPB_HEX[key];
    const raw = String(name).trim();
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(raw)) return raw;
    return "#EEE";
  }

  // Returns the mapped hex ONLY when the color is a direct entry in the theme
  // swatch map (Lilac, Blueberry, Oat, Sky Blue, Green, Black…). Unmapped
  // pattern/split colors (Sky/Green, Cherie, La Lune) return null so we fall
  // back to their swatch image instead.
  function mappedHex(name) {
    if (!name) return null;
    const key = String(name).trim().toLowerCase();
    return MPB_HEX[key] || null;
  }
  function swatchBG(value){
    const raw = String(value || "").trim();
    const parts = raw.split(/\s*(?:\/|&|\+|,)\s*/).filter(Boolean);
    if (parts.length >= 2){
      const a = hexFor(parts[0]);
      const b = hexFor(parts[1]);
      return `linear-gradient(90deg, ${a} 0 50%, ${b} 50% 100%)`;
    }
    return hexFor(raw);
  }

  // ---------- MPB staging (per block) ----------
  window.MPB = window.MPB || (function(){
    const map = new Map(); // bid -> items[]
    return {
      setSelections(bid, items){ map.set(String(bid), items || []); },
      /* Lets other blocks (the charm modal's strap-colour swatches) drive the set's
       * colour, so picking a strap colour there moves the collar and leash too. */
      setColor(value){
        let hit = false;
        document.querySelectorAll('[data-price-from-parent], .mpb-root, [data-bundle-title]').forEach(r => {
          if (typeof r.__mpbSetColor === 'function') { r.__mpbSetColor(value); hit = true; }
        });
        return hit;
      },
      getStagedLineItems(peek=false){
        const flat = Array.from(map.values()).flat();
        if (!peek) map.clear();
        return flat;
      }
    };
  })();

  /* buy-buttons peeks at window.MPB.getStagedLineItems() the moment ADD TO CART is
   * pressed; if the map is stale or has been popped since the last render it sees
   * nothing and falls back to adding the page's product alone. Re-stage in the capture
   * phase so the map is always current at click time. */
  document.addEventListener('click', (e) => {
    const t = e.target && e.target.closest
      ? e.target.closest('button[type="submit"], [js-add-to-cart], [data-add-to-cart], .product-form__submit')
      : null;
    if (!t) return;
    document.querySelectorAll('.mpb[data-bid]').forEach((el) => {
      if (typeof el.__mpbRestage === 'function') el.__mpbRestage();
    });
  }, true);


  /* ---- staged charm subtotal -------------------------------------------------
   * Charms are staged separately by the charm builder (window.CIKB) and end up in the
   * SAME merged bundle line as the products. percentageDecrease applies to that whole
   * line, so discounting naively would discount the charms too. Price the staged charms
   * from the cikb-payload maps (same source bundle-set-total.js uses) so the discount
   * can be scaled to hit the components only. */
  function charmPriceMap() {
    const map = new Map();
    document.querySelectorAll('script[id^="cikb-payload-"]').forEach((node) => {
      let data = null;
      try { data = JSON.parse(node.textContent || "null"); } catch (e) { return; }
      const charms = data && Array.isArray(data.charms) ? data.charms : [];
      charms.forEach((c) => {
        (c.variants || []).forEach((v) => {
          if (v && v.id != null && v.price != null) map.set(Number(v.id), Number(v.price) || 0);
        });
      });
    });
    return map;
  }

  function stagedCharmSubtotal() {
    try {
      const items = (window.CIKB && typeof window.CIKB.peekLineItems === "function")
        ? window.CIKB.peekLineItems() : [];
      if (!items || !items.length) return 0;
      const prices = charmPriceMap();
      return items.reduce(
        (sum, it) => sum + (prices.get(Number(it.id)) || 0) * (Number(it.quantity) || 1), 0);
    } catch (e) { return 0; }
  }

  function boot(){
    document.querySelectorAll('.mpb[data-bid]').forEach(init);
    // NOTE: no wireATC(); the theme's buy-buttons handles add-to-cart
  }

  function init(root){
    if (root.__mpbMounted) return;
    root.__mpbMounted = true;

    const bid = root.dataset.bid;
    const discountPercent = Math.max(0, parseFloat(root.dataset.discountPercent || "0")) || 0;
    const PREORDER_NOTE = root.dataset.preorderNote || "";
    const stageOnly = String(root.dataset.stageOnly || "") === "true";
    /* When the parent is itself a cart line it carries the set price, and the components
     * are staged at \u00a30 only so the merged line adds up — they are what the customer is
     * buying, not extras thrown in. Badging them FREE and summing to \u00a30 reads as the
     * whole set being free. Where the parent is display-only (stage_only, as on the walk
     * sets) a free: child really is a giveaway, and those keep their badge and pill. */
    const componentsPricedByParent = !stageOnly;
    const parentPrice = Number(root.dataset.parentPrice || 0) || 0;
    const bundleTitle = root.dataset.bundleTitle || "";
    const priceFromParent = String(root.dataset.priceFromParent || "") === "true";
    const freeCharms = String(root.dataset.freeCharms || "") === "true";
    const LINK_COLORS = String(root.dataset.linkColors || "") === "true";
    const SHARED_COLOR = String(root.dataset.sharedColorRow || "") === "true";

    const listEl    = root.querySelector(`#mpb-list-${bid}`);
    const totalEl   = root.querySelector(`#mpb-total-${bid}`);
    const compareEl = root.querySelector(`#mpb-compare-${bid}`);
    const headTotalEl   = root.querySelector(`#mpb-headtotal-${bid}`);
    const headCompareEl = root.querySelector(`#mpb-headcompare-${bid}`);
    const headBadgeEl   = root.querySelector(`#mpb-headbadge-${bid}`);

    const products = readPayload(root, bid);
    if (!products.length) {
      listEl.innerHTML = `<div style="opacity:.7">No bundle products configured.</div>`;
      window.MPB.setSelections(bid, []);
      return;
    }

    const selected = new Map(); // slot -> variant

    renderAll();

    // Size-guide dialog (collar): close on the × button or a backdrop click.
    const sgDialog = document.getElementById('mpb-sizeguide-' + bid);
    if (sgDialog && !sgDialog.__wired) {
      sgDialog.__wired = true;
      sgDialog.addEventListener('click', (e) => {
        if (e.target === sgDialog || (e.target.closest && e.target.closest('[data-sg-close]'))) sgDialog.close();
      });
    }

    function renderAll(){
      listEl.innerHTML = "";

      /* slot -> fn(colourValue): moves that card to the named colour if it has one.
       * Populated as each card renders so any card can drive the others. */
      const colorAppliers = new Map();
      /* slot -> the colour metadata needed to rebuild that row elsewhere */
      const colorUI = new Map();
      let syncingColor = false;

      products.forEach(prod => {
        const { slot, title, featured_image, variants = [], options = [] } = prod;

        // Collar gets a size DROPDOWN (others keep chips). Limited colors get a
        // "Limited Edition" sub-group, driven by the product's custom.limited_colors metafield.
        const isCollar = /collar/i.test(prod.handle || title || "");
        const limitedSet = new Set(
          String(prod.limitedColors || "").split(",").map(s => s.trim().toLowerCase()).filter(Boolean)
        );
        const isLimited = (val) => limitedSet.has(String(val).trim().toLowerCase());

        const colorIdx = options.findIndex(o => /color/i.test(o.name || o));
        const sizeIdx  = options.findIndex((o, i) => i !== colorIdx && /size|length|dimension/i.test((o.name||o)));
        const otherIdx = sizeIdx === -1 ? options.findIndex((o,i)=> i!==colorIdx) : sizeIdx;

        // default variant (prefer available), or restore the shopper's prior pick
        const def = variants.find(v => v.available) || variants[0];
        const persistKey = `${bid}::${slot}`;
        const persistedId = MPB_SEL.get(persistKey);
        const initial = (persistedId != null && variants.find(v => String(v.id) === String(persistedId))) || def;
        selected.set(slot, initial);

        const card = document.createElement('div');
        card.className = 'mpb-card' + (prod.free === true && !componentsPricedByParent ? ' is-free-item' : '');
        /* Name the card. Nothing in the DOM said which product a card was for, so anything
         * outside this closure wanting "the collar's colour" had to take the first colour
         * row on the page — which on a set with independent colours is the leash. */
        card.dataset.slot = String(slot);
        if (prod.handle) card.dataset.handle = prod.handle;
        if (isCollar) card.dataset.isCollar = 'true';
        if (prod.free === true && !componentsPricedByParent) {
          const tag = document.createElement('span');
          tag.className = 'mpb-free-tag';
          tag.textContent = 'FREE';
          card.appendChild(tag);
        }

        const imgWrap = document.createElement('div');
        imgWrap.className = 'mpb-card__img';
        const imgEl = document.createElement('img');
        imgEl.alt = ""; /* the card title right below names the product */
        imgEl.src = (initial?.featured_image) || featured_image || "";
        imgWrap.innerHTML = "";
        imgWrap.appendChild(imgEl);

        const head = document.createElement('div');
        head.className = 'mpb-card__head';

        const titleEl = document.createElement('div');
        titleEl.className = 'mpb-card__title';
        titleEl.textContent = title || "Product";

        const priceLine = document.createElement('div');
        priceLine.className = 'mpb-price';
        const was = document.createElement('s'); was.className = 'was';
        const now = document.createElement('span');

        /* Per-product preorder note: shown under a bundle item when the variant the
         * customer has selected is out of stock, mirroring the OOS note on a normal PDP
         * so the ship date is visible at the point of choice rather than only in cart. */
        const preorderEl = document.createElement('div');
        preorderEl.className = 'mpb-preorder';
        preorderEl.hidden = true;
        function setPreorderFor(variant){
          /* available === false means SOLD OUT, not preorder — a backordered variant
           * still reports available:true. Mirror the theme's own rule. */
          const backordered =
            !!variant &&
            !!variant.tracked &&
            variant.policy === 'continue' &&
            Number(variant.qty || 0) <= 0 &&
            !(window.__preorder && window.__preorder.isReadyToShip && window.__preorder.isReadyToShip(variant));
          const oos = backordered || (variant && variant.available === false);
          if (oos && PREORDER_NOTE) {
            preorderEl.textContent = PREORDER_NOTE;
            preorderEl.hidden = false;
          } else {
            preorderEl.textContent = '';
            preorderEl.hidden = true;
          }
        }

        const isFreeSlot = prod.free === true && !componentsPricedByParent;
        function setPriceFor(variant){
          setPreorderFor(variant);
          const p  = Number(variant?.price || 0);
          const cp = Number(variant?.compare_at_price || 0);
          if (isFreeSlot) {
            /* Included free: show FREE with the real price struck through, so the value
             * of the giveaway is visible. The money comes off the merged bundle line
             * rather than this item, which is why the cart shows one saving for the set. */
            now.textContent = 'FREE';
            now.classList.add('is-free');
            was.hidden = false;
            was.textContent = moneyFmt(cp > p ? cp : p);
            return;
          }
          /* A component staged at $0 has no price of its own to show — the set price sits
           * in the headline. "$0 $38" reads as the item being free, which is the thing
           * this whole distinction exists to avoid, so show nothing at all. */
          if (componentsPricedByParent && p === 0) {
            now.textContent = "";
            was.hidden = true;
            was.textContent = "";
            return;
          }
          now.textContent = moneyFmt(p);
          if (cp > p) { was.hidden = false; was.textContent = moneyFmt(cp); }
          else { was.hidden = true; was.textContent = ""; }
        }
        setPriceFor(initial);
        priceLine.append(now, was);

        const optWrap = document.createElement('div');
        optWrap.className = 'mpb-card__options';
        optWrap.appendChild(preorderEl);

        const colorLabelText = (v) =>
          'Color - ' + ((v && v.options && colorIdx > -1) ? (v.options[colorIdx] || '') : '');
        let colorLabelEl = null;
        let sizeValueEl = null;

        function updateCardVisuals(variant){
          setPriceFor(variant);
          const src = variant.featured_image || featured_image || "";
          if (src) imgEl.src = src;
          if (colorLabelEl) colorLabelEl.textContent = colorLabelText(variant);
          if (sizeValueEl && otherIdx > -1) sizeValueEl.textContent = ' ' + (variant.options[otherIdx] || '');
          if (sizeRow) refreshSizeRow(sizeRow, variants, colorIdx, otherIdx, variant);
          if (card.__refreshSwatches) card.__refreshSwatches(variant);
          recalcAndStage();
        }

        // COLOR SWATCHES
        if (colorIdx > -1) {
          const row = document.createElement('div');
          row.className = 'mpb-opt-row';

          // Native option-value swatches (hex + optional swatch image) from the payload.
          const colorSwatches = prod.colorSwatches || {};

          const colorValues = [];
          variants.forEach(v => {
            const val = v.options[colorIdx];
            if (val && !colorValues.includes(val)) colorValues.push(val);
          });

          function makeSwatch(val, currentOther, isActive){
            const sw = document.createElement('button');
            sw.type = "button";
            sw.className = 'mpb-swatch';
            sw.setAttribute('aria-label', val);

            // inner fill — match the PDP swatches:
            //  • a real theme-mapped color (Lilac/Blueberry/Oat/…) -> solid hex chip
            //  • otherwise a pattern/split color (Sky/Green/Cherie/La Lune) -> swatch image
            const fill = document.createElement('span');
            fill.className = 'mpb-swatch__fill';
            const swData = colorSwatches[val] || {};
            const mapped = mappedHex(val);
            if (swData.image) {
              fill.classList.add('has-img');
              fill.style.backgroundColor = swData.color || mapped || swatchBG(val);
              fill.style.backgroundImage = `url("${swData.image}")`;
            } else if (mapped) {
              fill.style.backgroundColor = mapped;
            } else {
              fill.style.backgroundColor = swData.color || swatchBG(val);
            }
            sw.appendChild(fill);

            const availableWithOther = variants.some(v =>
              v.options[colorIdx] === val &&
              (otherIdx === -1 || v.options[otherIdx] === currentOther) &&
              v.available
            );
            if (!availableWithOther) {
              sw.classList.add('is-oos');
              sw.setAttribute('aria-disabled','true');
              sw.tabIndex = -1;
            }
            if (isActive) sw.classList.add('is-active');

            sw.addEventListener('click', () => {
              if (sw.classList.contains('is-oos')) return;
              const current = selected.get(slot);
              const target = chooseVariant(variants, {
                [colorIdx]: val,
                [otherIdx]: current ? current.options[otherIdx] : undefined
              });
              if (!target) return;
              selected.set(slot, target);
              updateCardVisuals(target);

              /* A set is sold as a matched pair, so a colour pick moves the other items
               * to the same colour when they offer it. Guarded against re-entry so the
               * cascade can't fight itself. */
              if (LINK_COLORS && !syncingColor) {
                syncingColor = true;
                try {
                  const myGroup = (colorUI.get(slot) || {}).group;
                  colorAppliers.forEach((apply, otherSlot) => {
                    if (otherSlot === slot) return;
                    if ((colorUI.get(otherSlot) || {}).group !== myGroup) return;
                    apply(val);
                  });
                } finally { syncingColor = false; }
              }
            });

            return sw;
          }

          function refreshSwatchRow(currentVariant){
            row.innerHTML = "";
            const currentOther = currentVariant ? currentVariant.options[otherIdx] : undefined;
            const addSwatch = (val) => {
              const isActive = currentVariant && currentVariant.options[colorIdx] === val;
              row.appendChild(makeSwatch(val, currentOther, isActive));
            };
            // Standard colors first, then a "Limited Edition" label + the limited ones.
            colorValues.filter(v => !isLimited(v)).forEach(addSwatch);
            const limited = colorValues.filter(v => isLimited(v));
            if (limited.length) {
              const lbl = document.createElement('span');
              lbl.className = 'mpb-limited-label';
              lbl.textContent = 'Limited Edition';
              row.appendChild(lbl);
              limited.forEach(addSwatch);
            }
          }

          refreshSwatchRow(initial);

          /* Exposed so a colour pick on a sibling card can move this one too. */
          colorAppliers.set(slot, (wantedVal) => {
            /* group is assigned once the rows are built; slots only follow their own. */
            const match = colorValues.find(
              c => String(c).toLowerCase() === String(wantedVal).toLowerCase()
            );
            if (!match) return;
            const cur = selected.get(slot);
            if (cur && cur.options[colorIdx] === match) return;
            const target = chooseVariant(variants, {
              [colorIdx]: match,
              [otherIdx]: cur ? cur.options[otherIdx] : undefined
            });
            if (!target) return;
            selected.set(slot, target);
            updateCardVisuals(target);
          });

          colorLabelEl = document.createElement('div');
          colorLabelEl.className = 'mpb-opt__label';
          colorLabelEl.textContent = colorLabelText(initial);
          const colorBlock = document.createElement('div');
          colorBlock.className = 'mpb-opt mpb-opt--color';
          colorBlock.append(colorLabelEl, row);
          optWrap.appendChild(colorBlock);

          colorUI.set(slot, { slot, colorIdx, colorValues, colorSwatches, isLimited,
                              blockEl: colorBlock, title: title || '',
                              handle: String(prod.handle || '').toLowerCase() });
          card.__refreshSwatches = refreshSwatchRow;
        }

        // SIZE / OTHER CHIPS
        let sizeRow = null;
        if (otherIdx > -1) {
          sizeRow = document.createElement('div');
          sizeRow.className = 'mpb-opt-row';

          function makeSizeChip(val, available, active) {
            const chip = document.createElement('button');
            chip.type = "button";
            chip.className = 'mpb-chip';
            chip.textContent = val;
            if (!available) { chip.classList.add('is-oos'); chip.setAttribute('aria-disabled','true'); chip.tabIndex = -1; }
            if (active) chip.classList.add('is-active');

            chip.addEventListener('click', () => {
              if (chip.classList.contains('is-oos')) return;
              const current = selected.get(slot);
              const desired = chooseVariant(variants, {
                [otherIdx]: val,
                [colorIdx]: current ? current.options[colorIdx] : undefined
              });
              if (!desired) return;
              selected.set(slot, desired);
              updateCardVisuals(desired);
            });

            return chip;
          }

          function refreshSizeRow(row, variants, colorIdx, otherIdx, currentVariant){
            row.innerHTML = "";
            const values = [];
            variants.forEach(v => {
              const val = v.options[otherIdx];
              if (val && !values.includes(val)) values.push(val);
            });
            const availFor = (val) => variants.some(v =>
              v.options[otherIdx] === val &&
              (colorIdx === -1 || v.options[colorIdx] === currentVariant.options[colorIdx]) &&
              v.available
            );

            // Collar uses a dropdown; everything else keeps the chip row.
            if (isCollar) {
              const sel = document.createElement('select');
              sel.className = 'mpb-size-select';
              sel.setAttribute('aria-label', 'Size');
              values.forEach(val => {
                const available = availFor(val);
                const opt = document.createElement('option');
                opt.value = val;
                opt.textContent = available ? val : `${val} — Sold out`;
                if (!available) opt.disabled = true;
                if (currentVariant && currentVariant.options[otherIdx] === val) opt.selected = true;
                sel.appendChild(opt);
              });
              sel.addEventListener('change', () => {
                const current = selected.get(slot);
                const desired = chooseVariant(variants, {
                  [otherIdx]: sel.value,
                  [colorIdx]: current ? current.options[colorIdx] : undefined
                });
                if (!desired) return;
                selected.set(slot, desired);
                updateCardVisuals(desired);
              });
              row.appendChild(sel);
              return;
            }

            values.forEach(val => {
              const availableWithColor = availFor(val);
              const isActive = currentVariant && currentVariant.options[otherIdx] === val;
              row.appendChild(makeSizeChip(val, availableWithColor, isActive));
            });
          }

          refreshSizeRow(sizeRow, variants, colorIdx, otherIdx, initial);
          const sizeLabel = document.createElement('div');
          sizeLabel.className = 'mpb-opt__label';
          const sizeLabelText = document.createElement('span');
          if (isCollar) {
            // "Size: <selected value>" — matches the collar PDP label format.
            sizeLabelText.textContent = 'Size:';
            sizeValueEl = document.createElement('span');
            sizeValueEl.className = 'mpb-size-name';
            sizeValueEl.textContent = ' ' + (initial && initial.options[otherIdx] || '');
            sizeLabelText.appendChild(sizeValueEl);
          } else {
            sizeLabelText.textContent = 'Size';
          }
          sizeLabel.appendChild(sizeLabelText);
          // Collar gets a ruler-icon "Size Guide" link that opens its metafield-driven chart.
          if (isCollar) {
            const sg = document.getElementById('mpb-sizeguide-' + bid);
            if (sg) {
              const sgLink = document.createElement('button');
              sgLink.type = 'button';
              sgLink.className = 'mpb-size-guide-link';
              sgLink.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="1.5"/><path d="M6 7v3M10 7v4M14 7v3M18 7v4"/></svg><span></span>';
              sgLink.querySelector('span').textContent = sg.getAttribute('data-sg-link') || 'Size Guide';
              sgLink.addEventListener('click', () => { try { sg.showModal(); } catch (e) { sg.setAttribute('open', ''); } });
              sizeLabel.appendChild(sgLink);
            }
          }
          const sizeBlock = document.createElement('div');
          sizeBlock.className = 'mpb-opt mpb-opt--size';
          sizeBlock.append(sizeLabel, sizeRow);
          optWrap.appendChild(sizeBlock);
        }

        head.append(titleEl, priceLine);
        const top = document.createElement('div');
        top.className = 'mpb-card__top';
        top.append(imgWrap, head);
        card.append(top, optWrap);
        listEl.appendChild(card);
      });

      /* One swatch row for the whole set. A matched-colour set has no reason to ask
       * twice, so the per-card rows are hidden and a single control drives every item. */
      /* Exposed for window.MPB.setColor — drives every slot at once. */
      root.__mpbSetColor = (val) => {
        if (!colorAppliers.size) return;
        syncingColor = true;
        try { colorAppliers.forEach((apply) => apply(val)); } finally { syncingColor = false; }
        if (typeof root.__mpbRepaintShared === 'function') root.__mpbRepaintShared();
      };

      if (SHARED_COLOR && colorUI.size) {
        const metas = [...colorUI.values()];

        /* Some items are sold as their own matched pair on a smaller palette — the bag
         * and the city leash come in two colours and must agree with each other, not
         * with the collar. Configured by handle rather than inferred: guessing from
         * palette size split every item onto its own row. */
        const groupHandles = String(root.dataset.independentColorGroup || '')
          .split(/[,\r\n]+/).map(x => x.trim().toLowerCase()).filter(Boolean);
        metas.forEach(m => {
          m.group = groupHandles.includes(m.handle) ? 'alt' : 'main';
          m.blockEl.hidden = true;
        });

        const mainMetas = metas.filter(m => m.group === 'main');
        const altMetas  = metas.filter(m => m.group === 'alt');
        const master = mainMetas[0] || metas[0];

        /* Name each colour row after what's actually in it. A fixed string listed
         * items the set doesn't contain — Hands-Free Walk Set has no bottle or
         * dispenser, but the label still claimed them. */
        const SHORT = [
          [/treat dispenser|dispenser/i, 'Treat Dispenser'],
          [/collar/i, 'Collar'],
          [/leash/i, 'Leash'],
          [/bottle/i, 'Bottle'],
          [/bag/i, 'Bag']
        ];
        const shortName = (title) => {
          for (const [re, name] of SHORT) if (re.test(title || '')) return name;
          return (title || '').trim();
        };
        const groupLabel = (group) => {
          const names = [];
          group.forEach(m => {
            const n = shortName(m.title);
            if (n && !names.includes(n)) names.push(n);
          });
          if (!names.length) return 'Color';
          const list = names.length === 1
            ? names[0]
            : names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1];
          return list + ' Color';
        };

        const wrap  = document.createElement('div');
        wrap.className = 'mpb-shared-color';
        const label = document.createElement('div');
        label.className = 'mpb-opt__label';
        const rowEl = document.createElement('div');
        rowEl.className = 'mpb-opt-row';

        function paintShared() {
          const sel = selected.get(master.slot);
          const cur = sel ? sel.options[master.colorIdx] : null;
          label.textContent = 'Color - ' + (cur || '');
          rowEl.innerHTML = '';

          const add = (val) => {
            const sw = document.createElement('button');
            sw.type = 'button';
            sw.className = 'mpb-swatch' + (val === cur ? ' is-active' : '');
            sw.setAttribute('aria-label', val);
            const fill = document.createElement('span');
            fill.className = 'mpb-swatch__fill';
            const swData = master.colorSwatches[val] || {};
            const mapped = mappedHex(val);
            if (swData.image) {
              fill.classList.add('has-img');
              fill.style.backgroundColor = swData.color || mapped || swatchBG(val);
              fill.style.backgroundImage = `url("${swData.image}")`;
            } else if (mapped) {
              fill.style.backgroundColor = mapped;
            } else {
              fill.style.backgroundColor = swData.color || swatchBG(val);
            }
            sw.appendChild(fill);
            sw.addEventListener('click', () => {
              colorAppliers.forEach(apply => apply(val));
              paintShared();
            });
            rowEl.appendChild(sw);
          };

          master.colorValues.filter(v => !master.isLimited(v)).forEach(add);
          const limited = master.colorValues.filter(v => master.isLimited(v));
          if (limited.length) {
            const lbl = document.createElement('span');
            lbl.className = 'mpb-limited-label';
            lbl.textContent = 'Limited Edition';
            rowEl.appendChild(lbl);
            limited.forEach(add);
          }
        }

        paintShared();
        root.__mpbRepaintShared = paintShared;
        wrap.append(label, rowEl);
        listEl.parentNode.insertBefore(wrap, listEl);

        if (altMetas.length) {
          /* Only worth naming the main row when there's a second one to distinguish
           * it from — on sets without the bag it's the only colour choice. */
          wrap.dataset.groupLabel = root.dataset.mainColorLabel || groupLabel(mainMetas);

          const altMaster = altMetas[0];
          const altWrap = document.createElement('div');
          altWrap.className = 'mpb-shared-color mpb-shared-color--alt';
          altWrap.dataset.groupLabel = root.dataset.independentColorLabel || groupLabel(altMetas);
          const altLabel = document.createElement('div');
          altLabel.className = 'mpb-opt__label';
          const altRow = document.createElement('div');
          altRow.className = 'mpb-opt-row';

          function paintAlt() {
            const sel = selected.get(altMaster.slot);
            const cur = sel ? sel.options[altMaster.colorIdx] : null;
            altLabel.textContent = 'Color - ' + (cur || '');
            altRow.innerHTML = '';
            const add = (val) => {
              const sw = document.createElement('button');
              sw.type = 'button';
              sw.className = 'mpb-swatch' + (val === cur ? ' is-active' : '');
              sw.setAttribute('aria-label', val);
              const fill = document.createElement('span');
              fill.className = 'mpb-swatch__fill';
              const swData = altMaster.colorSwatches[val] || {};
              const mapped = mappedHex(val);
              if (swData.image) {
                fill.classList.add('has-img');
                fill.style.backgroundColor = swData.color || mapped || swatchBG(val);
                fill.style.backgroundImage = `url("${swData.image}")`;
              } else if (mapped) fill.style.backgroundColor = mapped;
              else fill.style.backgroundColor = swData.color || swatchBG(val);
              sw.appendChild(fill);
              sw.addEventListener('click', () => {
                altMetas.forEach(m => {
                  const apply = colorAppliers.get(m.slot);
                  if (apply) apply(val);
                });
                paintAlt();
              });
              altRow.appendChild(sw);
            };
            altMaster.colorValues.filter(v => !altMaster.isLimited(v)).forEach(add);
            const lim = altMaster.colorValues.filter(v => altMaster.isLimited(v));
            if (lim.length) {
              const l = document.createElement('span');
              l.className = 'mpb-limited-label';
              l.textContent = 'Limited Edition';
              altRow.appendChild(l);
              lim.forEach(add);
            }
          }

          paintAlt();
          altWrap.append(altLabel, altRow);
          listEl.parentNode.insertBefore(altWrap, listEl);
        }
      }

      recalcAndStage();
    }

    function chooseVariant(variants, desiredByIndex){
      let match = variants.find(v =>
        Object.entries(desiredByIndex).every(([idx, val]) =>
          val === undefined || v.options[idx] === val
        ) && v.available
      );
      if (match) return match;
      match = variants.find(v =>
        Object.entries(desiredByIndex).every(([idx, val]) =>
          val === undefined || v.options[idx] === val
        )
      );
      return match || variants[0];
    }

    root.__mpbRestage = () => { try { recalcAndStage(); } catch (e) {} };

    function recalcAndStage(){
      let sumPrice = 0;
      let sumCompare = 0;
      const items = [];

      let freeSum = 0;   // list price of everything included free
      selected.forEach((v, slot)=>{
        if (!v) return;
        MPB_SEL.set(`${bid}::${slot}`, v.id); // persist pick across re-inits
        const slotProd = products.find(pp => String(pp.slot) === String(slot));
        const slotFree = slotProd && slotProd.free === true;
        /* A free item is still a real cart line — fulfilment has to pick and ship it.
         * It just contributes nothing to what the customer pays: its cost is taken back
         * off the merged bundle line, so the saving appears once on the set. */
        if (slotFree) freeSum += Number(v.price) || 0;
        else          sumPrice += Number(v.price) || 0;
        sumCompare += Number(v.compare_at_price || v.price) || 0;
        /* stage-only: the page's own product is the bundle's DISPLAY identity
         * (bundleParentVariantId), not a line item. linesMerge takes the title and image
         * from the parent variant and prices the line as the sum of the merged children
         * — exactly how the charm bundle works, where `charm-bar` never appears as a
         * line. Adding it as well left an orphan $60 set line beside the $63 bundle. */
        const base = stageOnly ? { _MPBStageOnly: "1" } : {};
        // The cart shows this on the merged line — use the real product name, not a placeholder.
        if (stageOnly && bundleTitle) base.bundleTitle = bundleTitle;
        if (slotFree) base._FreeItem = "1";   // underscore keeps it out of customer-facing display
        items.push({ id: String(v.id), quantity: 1, __props: base });
      });

      /* Discount is applied ONCE, after the loop — sumPrice is only complete here.
       *
       * Carry it into the CART, not just the on-page total: linesMerge prices the merged
       * line as the raw sum of its children, so without this the cart showed $75 while
       * the block advertised a discounted figure. The Function turns bundleDiscountPct
       * into price.percentageDecrease.
       *
       * Scale it so the money taken off equals discountPercent of the PRODUCTS only,
       * leaving staged charms at their full $3:
       *     off       = C * d/100
       *     effective = off / (C + H) * 100
       * With no charms H is 0 and this collapses back to d. */
      /* Derive the discount from the parent product's price when asked: the set sells
       * for what it sells for, and the components should add up to that. Falls back to
       * the fixed Discount percent when the parent has no price. */
      let pct = discountPercent;
      if (priceFromParent && parentPrice > 0 && sumPrice > parentPrice) {
        pct = (1 - parentPrice / sumPrice) * 100;
      }

      /* One percentage has to express everything, because linesMerge prices the merged
       * line as the raw sum of ALL its children and can only be reduced as a whole:
       *     merged sum S = sumPrice (payable) + freeSum (giveaways) + H (staged charms)
       *     money off    = freeSum + sumPrice * pct/100
       *     effective    = off / S * 100
       * Staged charms stay at full price; free items come off entirely. This is also why
       * the cart shows a single saving on the set rather than per line. */
      const H = stagedCharmSubtotal();
      const mergedSum = sumPrice + freeSum + H;
      /* "Free Charms" offers: the staged charms cost nothing either. The selector caps
       * how many can be added (Max charms), so this can't run away. */
      const charmsOff = freeCharms ? H : 0;
      const moneyOff = freeSum + charmsOff + (pct > 0 ? sumPrice * (pct / 100) : 0);
      let effectivePct = mergedSum > 0 ? (moneyOff / mergedSum) * 100 : 0;
      if (effectivePct < 0) effectivePct = 0;
      if (effectivePct > 100) effectivePct = 100;
      items.forEach((it) => {
        const props = it.__props || {};
        delete it.__props;
        if (effectivePct > 0) props.bundleDiscountPct = effectivePct.toFixed(6);
        if (Object.keys(props).length) it.properties = props;
      });

      /* sumPrice counts staged children only. With the parent priced separately the
       * children are all \u00a30, so the set would advertise \u00a30 unless the parent is added. */
      /* Normally every child of a parent-priced set is a $0 mirror, so sumPrice is 0 and
       * the set shows the parent price. But a colourway with no mirror variant (the treat
       * dispenser has no free Baby Pink/Valencia/Palma/Milos) stages the PAID child, and
       * pinning the display to parentPrice hid that while the cart still charged it —
       * $43 on the page, $55 at checkout. Add what is actually staged so the page cannot
       * understate the charge. freeSum is what the free slots actually stage: $0 for every
       * properly mirrored colour, so this is normally a no-op and collapses to parentPrice.
       * It cannot be discounted away either — the deployed Function has
       * ENABLE_PERCENTAGE_DISCOUNT = false, so bundleDiscountPct is ignored and the $0
       * mirror is the ONLY thing making a free slot free. */
      const discounted = componentsPricedByParent && parentPrice > 0
        ? parentPrice + sumPrice + freeSum
        : Math.round(sumPrice * (1 - pct/100));

      if (sumCompare > 0 && sumCompare > discounted) {
        compareEl.hidden = false;
        compareEl.setAttribute('aria-hidden', 'false');
        compareEl.textContent = moneyFmt(sumCompare);
      } else {
        compareEl.hidden = true;
        compareEl.setAttribute('aria-hidden', 'true');
        compareEl.textContent = '';
      }
      totalEl.textContent = moneyFmt(discounted);

      // Headline price = bundle (non-charm) total only. The charm subtotal is
      // folded into the bottom Total by bundle-set-total.js, never here.
      if (headTotalEl) headTotalEl.textContent = moneyFmt(discounted);
      if (headCompareEl) {
        if (sumCompare > 0 && sumCompare > discounted) {
          headCompareEl.hidden = false;
          headCompareEl.setAttribute('aria-hidden', 'false');
          /* "Value" is a claim about what the set is worth, and it is the right word only
           * when part of the set carries no price on the page — the free charms on the
           * walk-set builder, or a free item in a slot. On a plain two-product set every
           * item is priced, so the compare is an ordinary struck-through price and calling
           * it Value overstates what is being compared. */
          const impliesValue = freeSum > 0 || freeCharms;
          headCompareEl.textContent = moneyFmt(sumCompare) + (impliesValue ? ' Value' : '');
        } else {
          headCompareEl.hidden = true;
          headCompareEl.setAttribute('aria-hidden', 'true');
          headCompareEl.textContent = '';
        }
      }
      /* Pill callouts beside the price: what's included, and that it ships free. The
       * charms carry no price on this page, so saying so plainly matters. */
      (function renderHeadlinePills(){
        const head = root.querySelector('.mpb__headline');
        if (!head) return;
        let pills = head.querySelector('.mpb__pills');
        if (!pills) {
          pills = document.createElement('span');
          pills.className = 'mpb__pills';
          head.appendChild(pills);
        }
        const wanted = [];
        if (freeCharms) wanted.push({ key: 'charms', text: 'Free Charms Included' });
        /* Call out every included item, not just the charms. */
        products.filter(p => p && p.free === true).forEach((p, i) => {
          if (!componentsPricedByParent) {
            wanted.push({ key: 'free' + i, text: (p.title || 'Item') + ' Included Free' });
          }
        });
        if (String(root.dataset.freeShipping || 'true') === 'true') {
          wanted.push({ key: 'ship', text: 'Free Shipping' });
        }
        const have = new Set();
        pills.querySelectorAll('[data-pill]').forEach(el => {
          if (wanted.some(w => w.key === el.dataset.pill)) have.add(el.dataset.pill);
          else el.remove();
        });
        wanted.forEach(w => {
          if (have.has(w.key)) return;
          const el = document.createElement('span');
          el.className = 'mpb__pill mpb__pill--' + w.key;
          el.dataset.pill = w.key;
          el.textContent = w.text;
          pills.appendChild(el);
        });
      })();

      if (headBadgeEl) {
        const pct = sumCompare > discounted && discounted > 0
          ? Math.floor((1 - discounted / sumCompare) * 100) : 0;
        if (pct > 0) { headBadgeEl.hidden = false; headBadgeEl.textContent = pct + '% off'; }
        else { headBadgeEl.hidden = true; headBadgeEl.textContent = ''; }
      }

      window.MPB.setSelections(bid, items);
    }
  }

  // Register + boot LAST, so window.MPB, MPB_SEL, boot() and init() are all
  // defined before boot can run (this is a deferred script, so the immediate
  // call below executes synchronously once the DOM is already parsed).
  ["DOMContentLoaded", "shopify:section:load", "shopify:section:select"]
    .forEach(e => document.addEventListener(e, boot));
  if (document.readyState !== "loading") boot();

})();
